import _classCallCheck from "C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /*#__PURE__*/function (_Error) {
  _inherits(SentryError, _Error);

  /** Display name of this error instance. */
  function SentryError(message) {
    var _this;

    _classCallCheck(this, SentryError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SentryError).call(this, message));
    _this.message = message;
    ;
    _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), (this instanceof SentryError ? this.constructor : void 0).prototype);
    return _this;
  }

  return SentryError;
}(_wrapNativeSuper(Error));

export { SentryError };